import { cn } from "@/lib/cn";

export interface BarraSaldoProps {
  /** De −100 a 100: negativo crece hacia la izquierda en rojo, positivo hacia la derecha en verde. Se acota. */
  proporcion: number;
  /** Nombre accesible, ej. "Saldo de Ana: a favor USD 1.000,00". */
  etiqueta: string;
  className?: string;
}

/** Barra de saldo con el cero en el medio (cuentas corrientes): a la derecha lo que tiene a favor, a la izquierda lo
 * que debe. El largo es relativo a la lista (`proporcionSaldo` de `lib/cuentas.ts`). */
export function BarraSaldo({ proporcion, etiqueta, className }: BarraSaldoProps) {
  const p = Math.max(-100, Math.min(100, proporcion));
  // Medio ancho por lado; un saldo distinto de cero se ve siempre (mínimo 2 % del lado).
  const ancho = p === 0 ? 0 : Math.max(2, Math.abs(p)) / 2;
  return (
    <div role="img" aria-label={etiqueta} className={cn("relative h-3 w-full min-w-24 rounded-full bg-superficie-2", className)}>
      <div className="absolute inset-y-0 left-1/2 w-px bg-borde-fuerte" />
      {p !== 0 && (
        <div
          data-sentido={p > 0 ? "a_favor" : "debe"}
          className={cn("absolute inset-y-0", p > 0 ? "left-1/2 rounded-r-full bg-exito" : "right-1/2 rounded-l-full bg-peligro")}
          style={{ width: `${ancho}%` }}
        />
      )}
    </div>
  );
}
